import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { CREATE_MERCHANT_SAGE_CONNECTION } from 'src/graphql/mutations/merchants.mutation';
import { LogError } from 'src/lib';

export const useCreateMerchantSageConnection = ({
    merchantId,
    onRefetch,
}: {
    merchantId: string;
    sageAccessToken?: string;
    onRefetch: () => void;
}) => {
    const [createMerchantSageConnection] = useMutation(CREATE_MERCHANT_SAGE_CONNECTION, {
        onError: (error) => {
            showErrorToast(error?.message);
            LogError(error);
        },
        onCompleted: () => {
            showSuccessToast('Merchant Sage Connection created!');
            onRefetch();
        },
    });

    return {
        onCreateMerchantSageConnection: () =>
            createMerchantSageConnection({
                variables: {
                    input: {
                        merchantId,
                    },
                },
            }),
    };
};
